__turbopack_context__.v({
  "dataPolicyCollapsible": "CguMention-module__BbBZXa__dataPolicyCollapsible",
  "dataPolicyCollapsibleContent": "CguMention-module__BbBZXa__dataPolicyCollapsibleContent",
  "dataPolicyCollapsibleTitle": "CguMention-module__BbBZXa__dataPolicyCollapsibleTitle",
});
